import { render, staticRenderFns } from "./BookmarkButton.vue?vue&type=template&id=7a5cab5f&"
import script from "./BookmarkButton.vue?vue&type=script&lang=js&"
export * from "./BookmarkButton.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports